import { render } from "./PopupBagEditor.vue?vue&type=template&id=7b3104a6&scoped=true"
import script from "./PopupBagEditor.vue?vue&type=script&lang=js"
export * from "./PopupBagEditor.vue?vue&type=script&lang=js"

import "./PopupBagEditor.vue?vue&type=style&index=0&id=7b3104a6&scoped=true&lang=css"

import exportComponent from "/Users/alpha/Documents/IONS/project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3104a6"]])

export default __exports__